var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74794 10.3714H13.5828M7.74794 20.7715H25.2525M7.74794 26.7144H25.2525M7.74794 32.6573H13.5828M4.83051 40.0859H28.1699C28.9437 40.0859 29.6857 39.7728 30.2328 39.2156C30.78 38.6583 31.0873 37.9025 31.0873 37.1145V4.42848C31.0873 3.64041 30.78 2.8846 30.2328 2.32735C29.6857 1.77009 28.9437 1.45703 28.1699 1.45703H4.83051C4.05676 1.45703 3.3147 1.77009 2.76758 2.32735C2.22046 2.8846 1.91309 3.64041 1.91309 4.42848V37.1145C1.91309 37.9025 2.22046 38.6583 2.76758 39.2156C3.3147 39.7728 4.05676 40.0859 4.83051 40.0859Z",
    stroke: "white",
    strokeWidth: 2.32558,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2523 11.1144C25.6551 11.1144 25.9817 10.7818 25.9817 10.3715C25.9817 9.96124 25.6551 9.62865 25.2523 9.62865C24.8495 9.62865 24.5229 9.96124 24.5229 10.3715C24.5229 10.7818 24.8495 11.1144 25.2523 11.1144Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.32558
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongrid);
export default __webpack_public_path__ + "static/media/longrid.e08291132f1da7a429c1d3381aea7f00.svg";
export { ForwardRef as ReactComponent };